import { localize, toast, utils } from '@easygenerator/fragment-sdk';
import { LoggingType } from '@easygenerator/fragment-sdk/dist/utils/logger/constants';
import Config from '../config';
import { ICroppedImageMetadata } from '../types';
import { FILE_SIZES, imageFileTypes } from '../constants';

const config = Config.getInstance();

const { HttpWrapper, Logger } = utils;
const logger = Logger.getInstance();

const imageUploadError = localize('imageUploadError');
const imageSizeIsTooLarge = localize('imageSizeIsTooLarge');

const MAX_FILE_SIZE = 10;

function showAndLogError(massage: string) {
  toast.error(massage);
  logger.trackError(LoggingType.error, massage);
}

export async function uploadCroppedFile(
  file: File,
  originalImageUrl: string,
  imageMetadata: ICroppedImageMetadata,
  token: string
) {
  let fileExtension = '';
  if (file && file.name) {
    const parts = file.name.split('.');
    if (parts.length > 0) {
      const lastPart = parts[parts.length - 1];
      fileExtension = lastPart ? lastPart.toLowerCase() : '';
    }
  }

  if (fileExtension && !imageFileTypes.includes(fileExtension)) {
    showAndLogError(imageUploadError);
  }

  if (file.size > MAX_FILE_SIZE * FILE_SIZES.MB) {
    showAndLogError(imageSizeIsTooLarge);
    return false;
  }

  const options = {
    body: {
      originalImageUrl,
      width: imageMetadata.w,
      height: imageMetadata.h,
      left: imageMetadata.x,
      top: imageMetadata.y,
      scale: imageMetadata.scale
    },
    headers: {
      Authorization: `Bearer ${token}`
    },
    authScope: HttpWrapper.scope.api
  };

  try {
    return await HttpWrapper.post(`${config.mediaServiceUrl}/api/media/image/cropped-upload`, options);
  } catch (e) {
    showAndLogError(imageUploadError);
    return false;
  }
}
